import data from 'components/landing/data/table-headers.json';
import getProperty from 'utils/get-property';

export default function getDefaultCoverageHeaders ({ culture, familyCode }) {
    if (!culture) {
        return { verification: false, headers: null };
    }
    const tableHeaders = data[culture];
    if (!tableHeaders) {
        return { verification: false, headers: null };
    }

    const {
        BENEFIT_COLUMNS: columns,
        BENEFIT_TEXT: text,
        BENEFIT_ARRAY: array
    } = tableHeaders;

    if (
        !columns ||
        !text ||
        !array[familyCode] ||
        !array[familyCode].headers ||
        !array[familyCode]['selector-list']
    ) {
        return { verification: false, headers: null };
    }
    const selectedArr = array[familyCode].headers;
    const headers = selectedArr.map((item, index) => {
        const code = `${item}`;
        return {
            code,
            name: text[code],
            description: getProperty(
                columns,
                data => columns[code].description
            ),
            columnName: getProperty(
                columns,
                data => columns[code].name
            )
        };
    });
    return {
        verification: true,
        headers,
        selectorList: array[familyCode]['selector-list']
    };
}
